import { Action } from '@ngrx/store';
import {UserPackages} from '../purchase.model';

export enum PackageActionTypes {
  LoadPackages = '[Package] Load Packages',
  GetPackages = '[Package] Get Packages',
  GetPackagesFail = '[Package] Get Packages Fail'
}

export class LoadPackages implements Action {
  readonly type = PackageActionTypes.LoadPackages;
  constructor(public payload: UserPackages[]) {}
}

export class GetPackages implements Action {
  readonly type = PackageActionTypes.GetPackages;
}

export class GetPackagesFail implements Action {
  readonly type = PackageActionTypes.GetPackagesFail;
}


export type PackageActions = LoadPackages
  | GetPackages
  | GetPackagesFail;
